// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"172":"72f5aeee","193":"639ee3a0","860":"5833f963"}[chunkId] + ".chunk.css";
};